import React, { useState, useEffect } from 'react';
// import { ascending } from 'd3-array';
import ChartStrategyExec from './ChartStrategyExec';
import { fetchData } from './FetchData';

function filterData(data) {
  return data.filter((d) => {
    return true;
  });
}

function prepareChartStrategyExecData(data) {
  // usually more wrangling is required but the example data is simple
  return data;
}

const useData = (dataSet) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchNewData = async () => {
      try {
        setLoading(true);
        setError(false);
        const data = await fetchData(dataSet);
        const dataClean = filterData(data);
        setData(prepareChartStrategyExecData(dataClean));
        setLoading(false);
      } catch (err) {
        console.log(err);
        setError(err);
        setLoading(false);
      }
    };
    fetchNewData();
  }, [dataSet]);

  return [data, loading, error];
};

const ChartStrategyExecData = ({ id, title, dataProp }) => {
  const [dataSet, setDataSet] = useState(dataProp);
  const [data, loading, error] = useData(dataSet);
  return (
    <>
      <ChartStrategyExec
        data={data}
        error={error}
        id={id}
        loading={loading}
        title={title}
      />
    </>
  );
};

export default ChartStrategyExecData;
